import { create } from 'zustand';
import { api, setToken, ensureSharedCookie } from '../lib/api';

export interface User {
  _id: string;
  username: string;
  role: 'user' | 'admin';
  status: string;
  quota: number;
}

interface AuthState {
  user: User | null;
  loading: boolean;
  login: (username: string, password: string) => Promise<void>;
  setSession: (token: string, user: User) => void;
  logout: () => void;
  fetchMe: () => Promise<void>;
}

// xyz 是登录-only 面：账号在主站 wenzao.site 注册（邀请码/微信），这里只做账密登录
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  loading: false,
  async login(username, password) {
    set({ loading: true });
    try {
      const { data } = await api.post('/auth/login', { username, password });
      setToken(data.data.token);
      set({ user: data.data.user });
    } finally {
      set({ loading: false });
    }
  },
  setSession(token, user) {
    setToken(token);
    set({ user });
  },
  logout() {
    setToken(null);
    document.cookie = 'token=; Max-Age=0; path=/; domain=.wenzao.site; secure';
    document.cookie = 'token=; Max-Age=0; path=/; secure';
    set({ user: null });
  },
  async fetchMe() {
    if (!localStorage.getItem('token')) return;
    try {
      const { data } = await api.get('/auth/me');
      ensureSharedCookie(); // 存量会话补写共享 Cookie，供另一站引导
      set({ user: data.data.user });
    } catch {
      setToken(null);
      set({ user: null });
    }
  },
}));
